import { useState } from "react";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import app from "./firebase";
import styles from "./LoginForm.module.css";

const auth = getAuth(app);

export default function LoginForm() {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGoogleSignIn = async () => {
    setError("");
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.icon}>
          📦
        </div>
        <h1 className={styles.title}>Product Manager</h1>
        <p className={styles.subtitle}>Welcome back! Sign in to continue</p>
      </div>
      
      {error && (
        <div className={styles.errorMessage}>
          <span className={styles.errorIcon}>⚠️</span>
          {error}
        </div>
      )}
      
      <button
        onClick={handleGoogleSignIn}
        className={styles.googleAuth}
        disabled={loading}
      >
        <img
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          alt="Google"
          className={styles.googleIcon}
        />
        {loading ? "Signing in..." : "Continue with Google"}
      </button>
      
      <div className={styles.footer}>
        <p className={styles.footerText}>
          Secure authentication powered by Google
        </p>
      </div>
    </div>
  );
}
